import { useEffect } from "react";
import { compareDates } from "../../lib/listings";
import { useModalCalendarContext } from "../../components/training-plan/material/listingModal/listingModalCalendar";

export const useListingModalCalendarInvalidDate = () => {
  const { state, dispatch } = useModalCalendarContext();

  useEffect(() => {
    if (state.dateValue.isValid()) {
      const comparingDatesResult = compareDates(state.dateValue.toDate());

      dispatch({ invalidDate: comparingDatesResult });
      return;
    }

    dispatch({ invalidDate: true });
  }, [state.dateValue]);
};
